import React from 'react'
import { useState, useEffect, useRef } from 'react';
import './eventos.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { ThreeDots } from 'react-loader-spinner';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';


registerLocale('es', es);
setDefaultLocale('es');

// --- Salesforce Web-to-Lead (mismos valores que public/web-to-lead-enter.html) ---
const SALESFORCE_WEB_TO_LEAD_URL = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00Di8000000GvGt';
const SALESFORCE_ORG_ID = '00Di8000000GvGt';
const SALESFORCE_CAPTCHA_SETTINGS = {
    keyname: 'EnterAllSitesProduccion',
    fallback: 'true',
    orgId: SALESFORCE_ORG_ID,
    ts: ''
};
// El POST se hace contra un iframe oculto para no sacar al usuario de la SPA.
const SALESFORCE_TARGET_IFRAME = 'salesforce-web-to-lead-target';
const SHEETS_SUBMIT_URL = 'https://serverless-captcha-validation.vercel.app/submit';

// Site key del reCAPTCHA emparejada con el "reCAPTCHA API Key Pair" de Salesforce
// (keyname 'EnterAllSitesProduccion'). Debe ser la MISMA que la del HTML que sí
// funciona (public/web-to-lead-enter.html), porque Salesforce valida el token
// contra la secret key de ese par. En producción la inyecta Netlify vía
// REACT_APP_SITE_KEY; este valor queda como fallback para local/entornos sin env.
const SALESFORCE_RECAPTCHA_SITE_KEY = '6LdJ0tUtAAAAAPQp8wsdviXde6iObST9ggCzEmNN';

// El formulario de Eventos corresponde siempre al resto Ronda.
const RESTO = 'Ronda';
const EVENTO_INFANTIL = 'Eventos Infantiles';

export const EventForm = () => {

    
    //const siteKey = process.env.REACT_APP_SITE_KEY;
    //https://www.npmjs.com/package/react-google-recaptcha ver size invisble etc.

    const siteKey = useRef(null);
    const checkForSiteKey = () => {
        if (siteKey.current == null) {
            siteKey.current = process.env.REACT_APP_SITE_KEY || SALESFORCE_RECAPTCHA_SITE_KEY;
        }
        return siteKey.current;
    }
    


    const recaptcha = useRef();

    const [formSent, setFormSent] = useState(false);
    const [formSending, setFormSending] = useState(false);
    const [formSentError, setFormSentError] = useState(false);
    
    // Convierte la fecha ISO del date picker (yyyy-mm-dd) al formato que espera Salesforce (dd/mm/yyyy)
    const formatDateForSalesforce = (isoDate) => {
        if (!isoDate) {
            return '';
        }

        const parts = isoDate.split('-');
        if (parts.length !== 3) {
            return '';
        }

        return parts[2] + '/' + parts[1] + '/' + parts[0];
    };

    // Convierte la duración 'H:MM' a horas (ej: '1:30' -> '1.5')
    const formatDurationForSalesforce = (duration) => {
        const [hours, minutes] = String(duration).split(':').map(Number);
        const total = (hours || 0) + ((minutes || 0) / 60);

        return String(Number.isInteger(total) ? total : Math.round(total * 100) / 100);
    };

    // Campos que espera el Web-to-Lead de Salesforce (mismos name que public/web-to-lead-enter.html)
    const buildSalesforceFields = (captchaValue) => {
        const companyName = company.trim() || (name + ' ' + lastName).trim() || 'Particular';

        const fields = {
            oid: SALESFORCE_ORG_ID,
            retURL: 'https://estoesronda.com/home',
            lead_source: 'Web',
            first_name: name,
            last_name: lastName,
            company: companyName,
            email: email,
            phone: phone,
            captcha_settings: JSON.stringify(Object.assign({}, SALESFORCE_CAPTCHA_SETTINGS, { ts: String(Date.now()) })),
            'g-recaptcha-response': captchaValue,
            '00NiE0000001GsL': RESTO,                                       // Resto
            '00NiE0000001FQ3': formatDateForSalesforce(date),               // Fecha estimada (dd/mm/yyyy)
            '00NiE0000004mqr': fromTime,                                    // Horario del evento
            '00NiE0000001G7a': formatDurationForSalesforce(eventDuration),  // Duración del evento (hs)
            '00NiE0000004p5Z': selectedInterests,                           // Interés principal (detalle)
            '00NiE0000001GVl': currentlySelectedEvent,                      // Tipo de evento
            '00NiE0000001GYz': eventPeopleCount,                            // Cantidad de personas
            '00NiE0000001Gab': String(plusEighteen),                        // Mayores de 18
            '00NiE0000001GcD': String(underEighteen),                       // Menores de 18
            '00NiE0000001GfR': comment                                      // Comentarios / Detalles
        };

        return fields;
    };

    // Crea (una sola vez) el iframe oculto que recibe la respuesta de Salesforce
    const ensureSalesforceTarget = () => {
        let iframe = document.querySelector('iframe[name="' + SALESFORCE_TARGET_IFRAME + '"]');

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.name = SALESFORCE_TARGET_IFRAME;
            iframe.title = 'Salesforce Web to Lead';
            iframe.setAttribute('aria-hidden', 'true');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }

        return iframe;
    };

    // POST nativo al Web-to-Lead (igual que el form del HTML), apuntando a un iframe
    // oculto para no sacar al usuario de la SPA.
    const submitToSalesforce = (fields) => {
        ensureSalesforceTarget();

        const form = document.createElement('form');
        form.action = SALESFORCE_WEB_TO_LEAD_URL;
        form.method = 'POST';
        form.target = SALESFORCE_TARGET_IFRAME;
        form.style.display = 'none';

        Object.keys(fields).forEach((fieldName) => {
            const value = fields[fieldName];
            const values = Array.isArray(value) ? value : [value];

            values.forEach((singleValue) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = fieldName;
                input.value = singleValue == null ? '' : String(singleValue);
                form.appendChild(input);
            });
        });

        document.body.appendChild(form);
        form.submit();

        setTimeout(() => {
            if (form.parentNode) {
                form.parentNode.removeChild(form);
            }
        }, 1000);
    };

    // Backup a la planilla (no bloquea ni rompe el envío a Salesforce)
    const sendSheetsBackup = () => {
        const payload = {
            email: email,
            name: name,
            lastName: lastName,
            phone: phone,
            date: date ? date : '',
            plusEighteen: plusEighteen,
            underEighteen: underEighteen,
            eventType: currentlySelectedEvent,
            fromTime: fromTime,
            toTime: addTimeStrings(fromTime, eventDuration) || 'null',
            eventDuration: eventDuration,
            interests: selectedInterests,
            comment: comment,
            source: 'eventos'
        };

        fetch(SHEETS_SUBMIT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch((error) => {
            // El backup nunca debe romper el envío a Salesforce.
            console.log(error);
            setFormSentError(true);
        });
    };

    const submitForm = (event) => {
        event.preventDefault();

        // 1. FECHA OBLIGATORIA
        if (!date) {
            alert('Por favor seleccione una fecha.');
            return;
        }

        // 2. LA FECHA NO PUEDE SER ANTERIOR A HOY
        const selectedDate = new Date(date + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (selectedDate < today) {
            alert('La fecha estimada del evento no puede ser anterior al día de hoy.');
            return;
        }

        // 3. MAYORES + MENORES = CANTIDAD DE PERSONAS (EXCLUSIVO DE RONDA)
        if (RESTO === 'Ronda') {
            const totalPersonas = parseInt(eventPeopleCount, 10) || 0;

            if ((plusEighteen + underEighteen) !== totalPersonas) {
                alert("La suma de 'Mayores de 18' (" + plusEighteen + ") y 'Menores de 18' (" + underEighteen + ") debe ser igual a la 'Cantidad de personas' (" + totalPersonas + ').');
                return;
            }
        }

        // 4. RECAPTCHA COMPLETO
        const captchaValue = recaptcha.current ? recaptcha.current.getValue() : null;

        if (recaptcha.current && !captchaValue) {
            alert('Por favor verificar el reCAPTCHA!');
            return;
        }

        setFormSending(true);

        // 5. ENVÍO A SALESFORCE (crea el Lead) + BACKUP A LA PLANILLA
        // Salesforce valida el reCAPTCHA con g-recaptcha-response, por eso no se
        // consume el token antes en el endpoint /verify del serverless.
        submitToSalesforce(buildSalesforceFields(captchaValue));
        sendSheetsBackup();

        setFormSending(false);
        setFormSent(true);
    };


    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');

    // Campos que sólo existían en el formulario de web-to-lead
    const [company, setCompany] = useState('');
    const [eventPeopleCount, setEventPeopleCount] = useState('');


    const [date, setDate] = useState(undefined);
    const [plusEighteen, setPlusEighteen] = useState(0);
    const [underEighteen, setUnderEighteen] = useState(0);

    //event dropdown
    const [eventType, setEventType] = useState(['Evento corporativo', EVENTO_INFANTIL, 'Evento Social']);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [currentlySelectedEvent, setCurrentlySelectedEvent] = useState(eventType[0]);

    //date picker
    const timeRanges = ['10:00','11:00','12:00', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '20:00']
    const [startTimes, setStartTimes] = useState(timeRanges);
    
    const [fromTime, setFromTime] = useState('10:00');
    const [toTime, setToTime] = useState('1:00');
    const [openToTimeDropdown, setOpenToTimeDropdown] = useState(false);
    const [openFromTimeDropdown, setOpenFromTimeDropdown] = useState(false);



    const handleDropdown = (option) => {
        setCurrentlySelectedEvent(eventType[option]);
        setOpenDropdown(false);
    }


    const handlePlusEighteen = (add) => {
        if(add){
            setPlusEighteen(plusEighteen + 1);
        }else{
            if(plusEighteen >= 1){
                setPlusEighteen(plusEighteen - 1);
            }
        }
    }

    const handleUnderEighteen = (add) => {
        if(add){
            setUnderEighteen(underEighteen + 1);
        }else{
            if(underEighteen >= 1){
                setUnderEighteen(underEighteen - 1);
            }
        }
    }

    const [dateDayError, setDateDayError] = useState(false);

    const displayDateErrorMessage = () => {
        setDateDayError(true);
        setTimeout(() => {
            setDateDayError(false);
        }, 10000);
    }

        const handleDateChange = (date) => {
        if (!date) {
            setDate(null);
            return;
        }
        
        // Use a consistent date format that doesn't shift with timezone
        // Force the date to be interpreted in the local timezone without time part
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        
        setDate(formattedDate);
        };
    
    

    const handleTimePick = (time, from) => {
        if (from) {
            setFromTime(time);
            setOpenFromTimeDropdown(false);
        }
        else{
            setToTime(time);
            setOpenToTimeDropdown(false);
        }

    }

    function addTimeStrings(time, duration) {
        const [timeH, timeM] = time.split(':').map(Number);
        const [durH, durM] = duration.split(':').map(Number);

        let totalMinutes = timeM + durM;
        let totalHours = timeH + durH + Math.floor(totalMinutes / 60);
        totalMinutes = totalMinutes % 60;
        totalHours = totalHours % 24;

        return `${totalHours}:${totalMinutes.toString().padStart(2, '0')}`;
    }


    function subtractTimeStrings(time, duration) {
        const [timeH, timeM] = time.split(':').map(Number);
        const [durH, durM] = duration.split(':').map(Number);

        let totalMinutes = timeM - durM;
        let totalHours = timeH - durH;

        if (totalMinutes < 0) {
            totalMinutes += 60;
            totalHours -= 1;
        }

        if (totalHours < 0) {
            totalHours = (totalHours + 24) % 24;
        }

        return `${totalHours}:${totalMinutes.toString().padStart(2, '0')}`;
    }



    const [eventDuration, setEventDuration] = useState('1:00');

    

    const handleEventDuration = (add) => {
        
        if (add) {
            if (eventDuration != '6:00') {
                setEventDuration(addTimeStrings(eventDuration, '0:15'));
            }
        } else {
            if (eventDuration != '1:00') {
                setEventDuration(subtractTimeStrings(eventDuration, '0:15'));
            }
        }
    }

    // Mismos valores que el campo 'Interés Principal (Detalle)' de Salesforce (matriz Ronda)
    const [interests, setInterests] = useState(['Arcade By Sacoa', 'Artpoint', 'Bowling', 'Coctelería', 'Gastronomía', 'Iron Driver', 'Minigolf']);
    const [selectedInterests, setSelectedInterests] = useState([]);

    //Edge case logic for start times depending on event type and selected interests...

    useEffect(() => {
        if (currentlySelectedEvent) {
            if (currentlySelectedEvent === EVENTO_INFANTIL) {
                setStartTimes(timeRanges.slice(0, -3))
            } else {
                setStartTimes(timeRanges)
            }
        }
    }, [currentlySelectedEvent, selectedInterests])

    //

    const [comment, setComment] = useState('');

// You might also need to improve the visibility/accessibility of the input
// in your CSS to ensure iOS can interact with it properly

    const determineMinDate = () => {
        let today = new Date();
        let dd = today.getDate() + 1;
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if(dd < 10){
            dd = '0' + dd;
        }
        if(mm < 10){
            mm = '0' + mm;
        }

        return yyyy + '-' + mm + '-' + dd;
    }

    const determinMaxDate = () => {
        let today = new Date();
        let dd = today.getDate() + 1;
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear() + 1;

        if(dd < 10){
            dd = '0' + dd;
        }
        if(mm < 10){
            mm = '0' + mm;
        }

        return yyyy + '-' + mm + '-' + dd;
    }

    useEffect(() => {
    if (formSent && typeof window !== 'undefined') {
        try {
            window.scrollTo({
            top: 0,
            behavior: 'smooth'
            });
        } catch (error) {
            console.error('Error scrolling to top:', error);
        }
    }
    }, [formSent]);

  return (
    <div className={`event-form-wrapper ${formSending && 'sending'}`}>
        <div className='form-success' style={!formSent ? {opacity: 0, display: 'none'} : {opacity: 1, display: 'flex'}}>
            <div className='checkmark-wrapper'>
                    
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64"><path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50
                        l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/></svg>
            
            </div>
            <div className='form-success-text'>¡Hemos recibido tu solicitud!</div>
            <div className='form-success-text'>Nos pondremos en contacto a la brevedad.</div>
        </div>
        <form className='event-form-container' onSubmit={submitForm} style={formSent ? {opacity: 0, maxHeight: '10px'} : {opacity: 1, maxHeight: 'none'}}>
            <div className='event-form-row'>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>*Nombre</label>
                    <input type="text" className='event-form-input' value={name} onChange={(e) => {setName(e.target.value)}} required></input>
                </div>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>*Apellido</label>
                    <input type="text" className='event-form-input' value={lastName} onChange={(e) => {setLastName(e.target.value)}} required></input>
                </div>
            </div>
            <div className='event-form-row'>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>*Mail</label>
                    <input type="email" className='event-form-input' value={email} onChange={(e) => {setEmail(e.target.value)}} required></input>
                </div>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>*Telefono</label>
                    <input type="text" className='event-form-input' inputMode="numeric" value={phone} onChange={(e) => {setPhone(e.target.value.replace(/[^0-9]/g, ''))}} required></input>
                </div>
            </div>
            <div className='event-form-input-container'>
                <label className='event-form-label'>Empresa</label>
                <input type="text" className='event-form-input' maxLength={40} placeholder="Nombre de la empresa (Opcional)" value={company} onChange={(e) => {setCompany(e.target.value)}}></input>
            </div>
            <div className='event-form-row-3'>
                <div className='event-form-input-container'>
                <label className='event-form-label'>*Fecha</label>
                <div style={{position: 'relative', display: 'flex', flexDirection: 'column'}}>
                    <DatePicker
                    selected={date ? new Date(`${date}T00:00:00`) : null}
                    onChange={(date) => handleDateChange(date)}
                    minDate={new Date(determineMinDate())}
                    maxDate={new Date(determinMaxDate())}
                    dateFormat="yyyy-MM-dd"
                    locale="es"
                    placeholderText="Ver fechas"
                    required
                    className="event-form-date-input"
                    popperPlacement="bottom-start"
                    filterDate={(date) => {
                        const day = date.getDay();
                        return day !== 0 && day !== 6;
                    }}
                    customInput={
                        <div 
                        className="event-form-date-input" 
                        style={{cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                        >
                        <span>{date ? date : 'Ver fechas'}</span>
                        <div className='arrow-svg-wrapper'>
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.1992 1.22564L7.33534 7.08951C7.27907 7.14579 7.18783 7.14579 7.13156 7.08951L1.26768 1.22564" stroke="black" strokeWidth="0.813514" strokeLinecap="round"/>
                            </svg>
                        </div>
                        </div>
                    }
                    />
                    <div className='date-error' style={dateDayError ? {opacity: 1} : {opacity: 0}}>
                    Por favor seleccione un día de semana
                    </div>
                </div>
                </div>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>Horario de inicio</label>
                    <div className='event-form-date-input-container event-form-input' style={openFromTimeDropdown ? {borderBottomLeftRadius: '0', borderTopLeftRadius: '10px', borderBottomRightRadius: '0', borderTopRightRadius: '10px'} : {}}>
                        <div className='date-picker-wrapper time-picker' onClick={() => {setOpenFromTimeDropdown(!openFromTimeDropdown)}}>
                                {/*<input type='time' onChange={(event) => {setTime(event.target.value)}} value={time} className='time-input' required></input>*/}
                                <div className='time-text'>Desde: {fromTime}</div>
                                <div className='dropdown-select-container dropdown-max-height' style={!openFromTimeDropdown ? {display: 'none'} : {}}>
                                    {
                                        startTimes && startTimes.map((time, index) => (
                                            <div className='dropdown-option' onClick={() => {handleTimePick(time, true)}} key={index}>{time}</div>
                                        ))
                                    }
                                    
                                
                            </div>
                        </div>

                    </div>
                    
                </div>
                
                <div className='event-form-input-container event-form-input-container-mobile-row'>
                    <label className='event-form-label label-max-width-mobile'>Duracion del evento (hs)</label>
                    <div className='event-form-counter-input'>
                        <div className='sign-wrapper' onClick={() => {handleEventDuration(false)}} style={eventDuration === 1 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9976 11.0898H1.39355" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className='counter-input'>{eventDuration}</div>
                        <div className='sign-wrapper' onClick={() => {handleEventDuration(true)}} style={eventDuration === 6 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0322 22.3912V1.78711" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M1.7302 12.0891H22.3343" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            {currentlySelectedEvent === EVENTO_INFANTIL &&
            <div className='event-form-label event-warning' style={{marginTop: '-15px'}}>Los eventos infantiles pueden empezar como maximo a las 18hs.</div>
            }
                        <div className='event-form-input-container'>
                <label className='event-form-label'>*Interés principal (opcional)</label>
                <div className='checkbox-grid'>
                    {
                        interests.map((interest, index) => {
                            return (
                                
                                    <div className='checkbox-input' onClick={() => {
                                        if(selectedInterests.includes(interest)){
                                            setSelectedInterests(selectedInterests.filter((item) => item !== interest));
                                        }else{
                                            setSelectedInterests([...selectedInterests, interest]);
                                        }
                                    }} key={index} style={selectedInterests.includes(interest) ? {backgroundColor: '#20B2EB'} : {}}>
                                    {interest}
                                    </div>                             
                            )                        
                        })
                    }
                </div>
            </div>
            <div className='dropdown-wrapper' style={{display: 'flex', flexDirection: 'column', position: 'relative'}}>
                <div className='event-form-input-container'>
                    <label className='event-form-label'>*Tipo de evento</label>
                    <div className='event-form-dropdown-event-type' onClick={() => {setOpenDropdown(!openDropdown)}} style={openDropdown ? {borderBottomRightRadius: '0', borderBottomLeftRadius: '0', borderTopLeftRadius: '10px', borderTopRightRadius: '10px'} : {}}>
                        <div>{currentlySelectedEvent}</div>
                        <div className='arrow-svg-wrapper'>
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.1992 1.22564L7.33534 7.08951C7.27907 7.14579 7.18783 7.14579 7.13156 7.08951L1.26768 1.22564" stroke="black" strokeWidth="0.813514" strokeLinecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='dropdown-select-container time-picker no-padding' style={!openDropdown ? {display: 'none'} : {display: 'flex'}}>
                    {
                        eventType.map((option, index) => {
                            return <div className='dropdown-option' onClick={() => {handleDropdown(index)}} key={index}>{option}</div>
                        })
                    }
                </div>
            </div>
            <div className='event-form-input-container'>
                <label className='event-form-label'>Cantidad de personas</label>
                <input type="text" className='event-form-input' inputMode="numeric" maxLength={4} placeholder="Ej: 30" value={eventPeopleCount} onChange={(e) => {setEventPeopleCount(e.target.value.replace(/[^0-9]/g, ''))}}></input>
            </div>
            <div className='event-form-row-2'>
                <div className='event-form-input-container event-form-input-container-mobile-row'>
                    <label className='event-form-label label-max-width-mobile'>*Personas mayores de 18</label>
                    <div className='event-form-counter-input'>
                        <div className='sign-wrapper' onClick={() => {handlePlusEighteen(false)}} style={plusEighteen === 1 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9976 11.0898H1.39355" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className='counter-input'>{plusEighteen}</div>
                        <div className='sign-wrapper' onClick={() => {handlePlusEighteen(true)}} style={plusEighteen === 20 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0322 22.3912V1.78711" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M1.7302 12.0891H22.3343" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                
                <div className='event-form-input-container event-form-input-container-mobile-row'>
                    <label className='event-form-label label-max-width-mobile'>*Personas menores de 18</label>
                    <div className='event-form-counter-input'>
                        <div className='sign-wrapper' onClick={() => {handleUnderEighteen(false)}} style={underEighteen === 1 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9976 11.0898H1.39355" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className='counter-input'>{underEighteen}</div>
                        <div className='sign-wrapper' onClick={() => {handleUnderEighteen(true)}} style={underEighteen === 20 ? {color: '#8F8F8F'} : {}}>
                            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0322 22.3912V1.78711" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M1.7302 12.0891H22.3343" stroke="currentColor" strokeWidth="1.74901" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>

            </div>

            <div className='event-form-input-container'>
                <label className='event-form-label'>Querés contarnos más acerca de tu evento?</label>
                <textarea className='event-form-textarea' maxLength={3500} value={comment} onChange={(e) => {setComment(e.target.value)}}></textarea>
            </div>
            <div className='submit-row'>
                {formSending && <div style={{position: 'absolute', top: '100%'}}><ThreeDots/></div>}
                {checkForSiteKey() && 
            <ReCAPTCHA ref={recaptcha} sitekey={checkForSiteKey()}/>
                }
                <button type='submit' className='event-form-submit-button'>Enviar</button>
            </div>
        </form>
        
    </div>
  )
}
